<template>
  <SfSection
    :title-heading="title"
    class="RelatedProduct section"
    v-if="products && products.length"
  >
    <SfLoader :class="{ loading }" :loading="loading">
      <SfCarousel
        :settings="{ peek: 16, breakpoints: { 1023: { peek: 0, perView: 2 } } }"
        class="carousel"
      >
        <Sf-carouselItem
          class="carousel__item"
          v-for="(product, i) in products"
          :key="i"
        >
          <Sf-ProductCard
            :title="productGetters.getName(product)"
            :imageHeight="'260'"
            :imageWidth="'210'"
            :regular-price="
              product.priceMin === product.priceMax
                ? $n(product.priceMax, 'currency')
                : $n(product.priceMin, 'currency') +
                  '-' +
                  $n(product.priceMax, 'currency')
            "
            :special-price="
              productGetters.getPrice(product).special &&
              $n(productGetters.getPrice(product).special, 'currency')
            "
            :max-rating="5"
            :score-rating="productGetters.getAverageRating(product)"
            :show-add-to-cart-button="true"
            :is-in-wishlist="isInWishlist({ product })"
            :is-added-to-cart="isInCart({ product })"
            :link="
              localePath(
                `/p/${productGetters.getId(product)}/${productGetters.getSlug(
                  product
                )}`
              )
            "
            class="product-card"
            @click:wishlist="
              !isInWishlist({ product })
                ? addItemForWishlist({ product })
                : removeProductFromWishlist(product)
            "
            @click:add-to-cart="addItemToCart({ product, quantity: 1 })"
          >
            <template #image>
              <!--  -->
              <div
                class="catImg"
                @mouseleave="handlerMouseleaveProduct(product)"
                @mouseover="handlerMouseoverProduct(product)"
              >
                <nuxt-link
                  :to="
                    localePath(
                      `/p/${productGetters.getId(
                        product
                      )}/${productGetters.getSlug(product)}`
                    )
                  "
                >
                  <template
                    v-if="
                      MouseoverProduct &&
                      MouseoverProduct.goodId == product.goodId &&
                      MouseoverProduct.images.length > 1
                    "
                  >
                    <SfHero
                      class="productHero productImg"
                      style="overflow: hidden"
                      :sliderOptions="{
                        type: 'slider',
                        rewind: true,
                        autoplay: 1000,
                        perView: 1,
                        gap: 0,
                        hoverpause: false,
                      }"
                    >
                      <template v-for="(image, i) in MouseoverProduct.images">
                        <SfHeroItem
                          :key="i"
                          :image="image.normal"
                          :nuxtImgConfig="{ modifiers: { format: 'webp' } }"
                        >
                        </SfHeroItem>
                      </template>
                      <template #bullets>
                        <div></div>
                      </template>
                      <template #next>
                        <div></div>
                      </template>
                      <template #prev>
                        <div></div>
                      </template>
                    </SfHero>
                  </template>
                  <SfImage
                    v-else
                    class="productImg"
                    :class="{
                      mouseoverImg:
                        MouseoverProduct &&
                        MouseoverProduct.goodId === product.goodId,
                    }"
                    :src="product.imageUrl"
                    :alt="product.title"
                    :width="190"
                    :height="190"
                  />
                </nuxt-link>
              </div>
            </template>
            <template #price>
              <div style="margin: var(--product-card-margin, 0);height:28.8px;align-content: center;">
                <show-price :regular="productGetters.getPrice(product).regular" :special="productGetters.getPrice(product).special" />
              </div>
            </template>
          </Sf-ProductCard>
        </Sf-carouselItem>
      </SfCarousel>
    </SfLoader>
  </SfSection>
</template>

<script>
import {
  SfCarousel,
  SfProductCard,
  SfSection,
  SfLoader,
  SfHero,
  SfImage
} from '@storefront-ui/vue';
import {
  productGetters,
  useWishlist,
  wishlistGetters,
  useOCart
} from '@bee-hole/coms';
import showPrice from '~/components/Products/showPrice';
import { computed, ref } from '@vue/composition-api';
import { addBasePath } from '@vue-storefront/core';
import { useRouter } from '@nuxtjs/composition-api';

export default {
  name: 'RelatedProducts',
  components: {
    SfCarousel,
    SfProductCard,
    SfSection,
    SfLoader,
    SfHero,
    SfImage,
    showPrice
  },
  props: {
    title: String,
    products: Array,
    loading: Boolean
  },
  setup(props, context) {
    const MouseoverProduct = ref();
    const router = useRouter();
    const { addItem: addItemToCart, isInCart } = useOCart();
    const {
      addItem: addItemToWishlist,
      isInWishlist,
      removeItem: removeItemFromWishlist,
      wishlist
    } = useWishlist();
    const removeProductFromWishlist = (productItem) => {
      const productsInWhishlist = computed(() =>
        wishlistGetters.getItems(wishlist.value)
      );
      const product = productsInWhishlist.value.find(
        (wishlistProduct) => wishlistProduct.sku_id === productItem.sku_id
      );
      removeItemFromWishlist({ product });
    };
    const handlerMouseoverProduct = (product) => {
      MouseoverProduct.value = product;
    };
    const handlerMouseleaveProduct = (product) => {
      if (MouseoverProduct.value?.goodId === product.goodId) {
        MouseoverProduct.value = null;
      }
    };
    const addItemForWishlist = (product) => {
      if (product.product.skus.length > 1) {
        router.push(context.root.localePath(`/p/${product.product.goodId
          }/${product.product?.slug || product.product.title
          }`));
      } else {
        product.product.skuId = product.product.skus[0].skuId;
        addItemToWishlist(product);
      }
    };
    return {
      productGetters,
      addItemForWishlist,
      isInWishlist,
      removeProductFromWishlist,
      addItemToCart,
      isInCart,
      addBasePath,
      handlerMouseoverProduct,
      handlerMouseleaveProduct,
      MouseoverProduct
    };
  }
};
</script>

<style lang="scss" scoped>
.section {
  margin-top: var(--spacer-base);
}

.carousel {
  margin: 0 calc(0 - var(--spacer-sm)) 0 0;

  @include for-desktop {
    margin: 0;
  }

  &__item {
    margin: 1.9375rem 0 2.4375rem 0;
  }
}
</style>
<style lang="scss">
.RelatedProduct {
  margin: 0 var(--spacer-sm) !important;
}
</style>
